import React from 'react';
import EventQuestionAnswerList from '../../features/EventManagement/EventQuestionAnswerList';

const EventQuestionAnswer = () => {
    return (<>
        <EventQuestionAnswerList />
    </>)
}
export default EventQuestionAnswer;